import { Bold as m } from "../node_modules/@tiptap/extension-bold/dist/index.mjs";
import { Document as a } from "../node_modules/@tiptap/extension-document/dist/index.mjs";
import { Italic as l } from "../node_modules/@tiptap/extension-italic/dist/index.mjs";
import { Strike as x } from "../node_modules/@tiptap/extension-strike/dist/index.mjs";
import { Text as f } from "../node_modules/@tiptap/extension-text/dist/index.mjs";
import { Underline as s } from "../node_modules/@tiptap/extension-underline/dist/index.mjs";
import { CharacterCount as d, Dropcursor as c, UndoRedo as p } from "../node_modules/@tiptap/extensions/dist/index.mjs";
import { EditorExtensionEnum as r } from "../enums/editor-extensions-enum.mjs";
import { FontFamily as u } from "../extensions/font-family-extension/index.mjs";
import { createFontSizeExtension as E } from "../extensions/font-size-extension/index.mjs";
import { SimpleHardBreakExtension as g, HardBreakExtension as k } from "../extensions/hard-break-extension/index.mjs";
import { HeadingExtension as L } from "../extensions/heading-extension/index.mjs";
import { LineHeightExtension as S } from "../extensions/line-height-extension/index.mjs";
import { createSimpleLinkExtension as B, createLinkExtension as C } from "../extensions/link-extension/index.mjs";
import { ListItemExtension as I, OrderedListExtension as T, BulletListExtension as H } from "../extensions/list-extension/index.mjs";
import { ParagraphExtension as h } from "../extensions/paragraph-extension/index.mjs";
import { TextAlignExtension as F } from "../extensions/text-align-extension/index.mjs";
import { TextColor as y } from "../extensions/text-color-extension/index.mjs";
import { TextStyle as A } from "../extensions/text-style-extension/index.mjs";
import { TextBackgroundColor as D } from "../extensions/text-background-color-extension/index.mjs";
import { BlockImage as z } from "../extensions/image-extension/block-image.mjs";
import { InlineImage as O } from "../extensions/image-extension/inline-image.mjs";
import { Indent as U } from "../extensions/indent-extension/indent.mjs";
const ir = (i, e) => {
  const t = {
    [r.Document]: a,
    [r.Paragraph]: h,
    [r.Text]: f,
    [r.TextStyle]: A,
    [r.FontFamily]: u,
    [r.Heading]: L,
    [r.Bold]: m,
    [r.Italic]: l,
    [r.Strike]: x,
    [r.Underline]: s,
    [r.BulletList]: H,
    [r.OrderedList]: T,
    [r.ListItem]: I,
    [r.TextAlign]: F,
    [r.Link]: C(e == null ? void 0 : e[r.Link]),
    [r.SimpleLink]: B(
      e == null ? void 0 : e[r.Link]
    ),
    [r.History]: p,
    [r.TextColor]: y,
    [r.TextBackgroundColor]: D,
    [r.FontSize]: E(
      e == null ? void 0 : e[r.FontSize]
    ),
    [r.LineHeight]: S,
    [r.Indent]: U,
    [r.HardBreak]: k,
    [r.SimpleHardBreak]: g,
    [r.Substitution]: null,
    [r.SpecialCharacters]: null,
    [r.Image]: [z, O],
    [r.DropCursor]: c,
    [r.CharacterCount]: d
  };
  return i.flatMap((o) => {
    const n = t[o];
    return Array.isArray(n) ? n : [n];
  }).filter((o) => o !== null);
}, or = (i) => Object.values(r).reduce(
  (e, t) => ({
    ...e,
    [`has${r[t]}`]: i.includes(t)
  }),
  {}
);
export {
  or as getExistingExtensions,
  ir as getExtensions
};
